<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>work</mat-icon></div>
          <mat-card-title>Cargos</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          [showSituacao]="true"
          [(situacao)]="situacao"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Clique em <strong>Consultar</strong> para listar os cargos.
        </div>

        <table *ngIf="consultaRealizada" mat-table [dataSource]="cargos" class="full-width">
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef>Nome</th>
            <td mat-cell *matCellDef="let c">{{ c.nome }}</td>
          </ng-container>
          <ng-container matColumnDef="departamento">
            <th mat-header-cell *matHeaderCellDef>Departamento</th>
            <td mat-cell *matCellDef="let c">{{ c.departamentoNome || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td mat-cell *matCellDef="let c">{{ c.descricao || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="ativa">
            <th mat-header-cell *matHeaderCellDef>Situação</th>
            <td mat-cell *matCellDef="let c">{{ c.ativo !== false ? 'Ativo' : 'Inativo' }}</td>
          </ng-container>
          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let c" (click)="$event.stopPropagation()">
              <button mat-icon-button color="accent" matTooltip="Alterar" (click)="editar(c)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Inativar" (click)="inativar(c)" *ngIf="c.ativo !== false">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['nome','departamento','descricao','ativa','acoes']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['nome','departamento','descricao','ativa','acoes'];"
            class="wow-consulta__row" (click)="editar(row)"></tr>
        </table>
      </mat-card>
    </div>
  </div>
</main>
